// extracted by mini-css-extract-plugin
export default {"login":"login_login__LJq+W","img":"login_img__tlESi"};